import React, { useState, useEffect } from "react";
import { Button, makeStyles, Divider, Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import { EXCEL_FILE_TYPE } from "../../../util/Constants";
import UploadIcon from "@material-ui/icons/Publish";
import DownloadIcon from "@material-ui/icons/GetApp";
import FileExchange from "../../../services/FileExchange";
import DepotComponent from "./DepotComponent";

const Alert = (props) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const useStyles = makeStyles((theme) => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  input: {
    display: "none",
  },
  divider: {
    height: 10,
  },
  divider2: {
    height: 70,
  },
}));

const ZoneMaster = () => {
  const classes = useStyles();
  const [snackbarOpen, setsnackbarOpen] = useState(false);
  const [snackbarSeverity, setsnackbarSeverity] = useState("success");
  const [snackbarMessage, setsnackbarMessage] = useState("");

  const uploadZoneHandler = (event) => {
    const data = new FormData();
    data.append("file", event.target.files[0]);
    const path = "zone/upload";

    upload(data, path);
  };

  const uploadDeliveryNodeHandler = (event) => {
    const data = new FormData();
    data.append("file", event.target.files[0]);
    const path = "deliverynode/upload";

    event.target.value = null; //asi permite subir archivos consecutivamente

    upload(data, path);
  };

  const upload = (data, path) => {
    FileExchange.upload(data, path)
      .then((response) => {
        setsnackbarMessage("OK");
        setsnackbarSeverity("success");
        setsnackbarOpen(true);
      })
      .catch((error) => {
        setsnackbarMessage("" + error + " - " + error.response.data.message);
        setsnackbarSeverity("error");
        setsnackbarOpen(true);
      });
  };

  const downloadZoneHandler = (event) => {
    const path = "zone/download";

    download(path);
  };

  const downloadDeliveryNodeHandler = (event) => {
    const path = "deliverynode/download";

    download(path);
  };

  const download = (path) => {
    FileExchange.download(path)
      .then((response) => {
        setsnackbarMessage("OK");
        setsnackbarSeverity("success");
        setsnackbarOpen(true);
      })
      .catch((error) => {
        setsnackbarMessage("" + error + " - " + error.response.data.message);
        setsnackbarSeverity("error");
        setsnackbarOpen(true);
      });
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setsnackbarOpen(false);
  };

  return (
    <div className={classes.paper}>
      <div>
        <input
          accept={[EXCEL_FILE_TYPE]}
          className={classes.input}
          id="upload-zone-input"
          multiple
          type="file"
          onChange={uploadZoneHandler}
        />
        <label htmlFor="upload-zone-input">
          <Button
            variant="contained"
            color="secondary"
            component="span"
            endIcon={<UploadIcon />}
          >
            Subir Maestro de Zonas
          </Button>
        </label>
      </div>
      <Divider className={classes.divider} />
      <div>
        <Button
          variant="contained"
          color="primary"
          component="span"
          onClick={downloadZoneHandler}
          endIcon={<DownloadIcon />}
        >
          Descargar Maestro de Zonas
        </Button>
      </div>
      <Divider className={classes.divider} />
      <div>
        <input
          accept={[EXCEL_FILE_TYPE]}
          className={classes.input}
          id="upload-deliverynode-input"
          multiple
          type="file"
          onChange={uploadDeliveryNodeHandler}
        />
        <label htmlFor="upload-deliverynode-input">
          <Button
            variant="contained"
            color="secondary"
            component="span"
            endIcon={<UploadIcon />}
          >
            Subir Maestro de Nodos
          </Button>
        </label>
      </div>
      <Divider className={classes.divider} />
      <div>
        <Button
          variant="contained"
          color="primary"
          component="span"
          onClick={downloadDeliveryNodeHandler}
          endIcon={<DownloadIcon />}
        >
          Descargar Maestro de Nodos
        </Button>
      </div>

      <DepotComponent />

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={handleSnackbarClose}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default ZoneMaster;
